import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Component} from "@angular/core";

const debug = initDebugger('Ng2BoostrapKomponent');


let ng2LastetResolve = ()=>{};
const ng2LastetPromise = new Promise<void>((resolve, reject) => {
    ng2LastetResolve = resolve;
});

/** Promise som resolver når ng2 er lastet. */
export function nårNg2ErLastet():Promise<void>{
    return ng2LastetPromise;
}

/** Sørger for at den nedgraderte ng2-modulen blir lastet i ajs.
 * Øvrig kode kan benytte promiset {@link nårNg2ErLastet} for å vente på at ng2 er lastet.
 * Se
 * src/scripts/web/nedgraderteNg2Tjenester.ts
 * src/scripts/web/index.ts
 * src/scripts/web-ng2/bootstrap-ng2.ts */
@Component({
    selector: 'ng2-boostrap',
    template: '',
    standalone: true
})
export class Ng2BoostrapKomponent {
    static ajsSelector = 'ng2Boostrap';

    constructor() {
        debug('nedgraderte ng2-modul bootstrappet')
        ng2LastetResolve()
    }
}
